/**
 * Modelo de Dominio: ContactoPersona
 * 
 * Esta es la entidad de dominio del frontend Angular para contactos.
 * Corresponde a ContactoPersonaResponse del backend (Spring Boot).
 * 
 * NOTA: Solo aplica para personas jurídicas (NIT)
 * 
 * Arquitectura DDD Frontend:
 * - domain/model/ContactoPersona → Entidad de dominio (esta clase)
 * - domain/service/ContactoPersonaRepository → Puerto abstracto
 * - infrastructure/adapters/HttpContactoPersonaRepository → Adaptador HTTP
 * 
 * @author Emerson Rodriguez - Ingeneo
 */
export interface ContactoPersona {
  // Primary key
  nmconsecutivo?: number;
  
  // Foreign keys
  cdpersona?: number;
  cdrol?: number;
  cdcargo?: number;
  
  // Datos del contacto
  dsnombre?: string;
  dscargo?: string;
  dstelefono?: string;
  dscelular?: string;
  dsemail?: string;
  
  // Estado
  snactivo?: string;
  
  // Campos calculados/lookup del backend
  dsrol?: string;         // Descripción del rol desde tabla TPSC_ROLES
  dscargo_desc?: string;  // Descripción del cargo desde tabla TPSC_CARGOS
  
}

/**
 * Request DTO para crear/actualizar contactos
 */
export interface ContactoPersonaRequest {
  cdpersona: number;
  cdrol?: number;
  cdcargo?: number;
  dsnombre: string;
  dscargo?: string;
  dstelefono?: string;
  dscelular?: string;
  dsemail?: string;
  /** Consecutivo centro trabajo (si aplica). Inserta en TPSC_CONTAC_CENTRO_TRAB */
  nmconsecCentroTrabajo?: number;
}

/**
 * Rol de contacto - desde tabla TPSC_ROLES
 */
export interface RolContacto {
  cdrol: number;
  dsrol: string;
  snactivo?: string;
}

/**
 * Cargo de contacto - desde tabla TPSC_CARGOS
 */
export interface CargoContacto {
  cdcargo: number;
  dscargo: string;
  snactivo?: string;
}

/**
 * Constantes para roles comunes
 */
export const ROLES_CONTACTO = {
  REPRESENTANTE_LEGAL: 1,
  CONTACTO_COMERCIAL: 2,
  CONTACTO_TECNICO: 3,
  CONTADOR: 4
};

/**
 * Crea un ContactoPersonaRequest vacío
 */
export function createEmptyContactoRequest(): ContactoPersonaRequest {
  return {
    cdpersona: 0,
    cdrol: undefined,
    cdcargo: undefined,
    dsnombre: '',
    dscargo: undefined,
    dstelefono: undefined,
    dscelular: undefined,
    dsemail: undefined
  };
}
